

import {  
  loadChangeLogDataInProgress,
  loadChangeLogDataSuccess,
  loadChangeLogDataFailure,
  loadChangeLogTypeListSuccess,
  loadChangeLogSubTypeListSuccess
} from "../state/changelog/actions";
import { oktaAuth } from '../auth/okta';
import configData from "../config.json";
import dayjs from 'dayjs';
import { errorSweetAlert } from "../components/SweetAlertMessages";
const serverBasePath=configData.SERVER_API_URL;
let abortController = null;

export const loadChangeLogs = (searchText,searchBy,logType='',changeSubLogType='',fromDate='',toDate='',page=0,pageSize=10) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token'); 
    if (abortController) {
        abortController.abort();
    }
    abortController = new AbortController();
    const signal = abortController.signal;
    try {
        let formatedFromDate = fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : '';
        let formatedToDate = toDate ? dayjs(toDate).format('YYYY-MM-DD') : '';
        dispatch(loadChangeLogDataInProgress());
        const response = await fetch(serverBasePath+"/changelog/getChangelogData?searchText="+searchText+"&searchBy="+searchBy+"&logType="+logType+"&subLogType="+changeSubLogType+"&fromDate="+formatedFromDate+"&toDate="+formatedToDate+"&page="+page+"&pageSize="+pageSize,
        {   
            signal,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
      
        if(response.status===401){
            window.location.reload(false);
            return;
        }
        const data = await response.json();
        dispatch(loadChangeLogDataSuccess(data));    
    } catch (e) {
        dispatch(loadChangeLogDataFailure());    
        if (e.name === "AbortError") {
           //errorSweetAlert({message:'The operation was aborted.'}); 
        }
    }
};

export const loadChangeLogType = () => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
      const response = await fetch(serverBasePath+"/changelog/getChangeLogTypeList",
        {
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        if(response.status===401){
            window.location.reload(false);
            return;
        }
        const data = await response.json();
        dispatch(loadChangeLogTypeListSuccess(data));     
    } catch (e) {   
        dispatch(loadChangeLogDataFailure());   
        errorSweetAlert(e);  
    }
};

export const loadChangeLogSubType = (logType) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
      const response = await fetch(serverBasePath+"/changelog/getChangeLogSubType/"+logType,
        {
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        if(response.status===401){
            window.location.reload(false);
            return;
        }
        const data = await response.json();
        dispatch(loadChangeLogSubTypeListSuccess(data));     
    } catch (e) {   
        dispatch(loadChangeLogDataFailure());   
        errorSweetAlert(e); 
    }
};
